import _ from 'underscore';
import Store from '@nichoth/state';

var Chat = Store.extend({
    _state: {
        // map eventID's to lists of moderators
        data: {}
    },

    add: function (data) {
        this._state.data[data.eventID] = this._state.data[data.eventID] || [];
        this._state.data[data.eventID].push(data);
        return this.publish();
    },

    set: function (mods) {
        this._state.data = mods.reduce(function (acc, mod) {
            acc[mod.eventID] = (acc[mod.eventID] || []).concat(mod);
            return acc;
        }, {});
        return this.publish();
    },

    delete: function (mod) {
        if (!this._state.data[mod.eventID]) return this;
        var i = _(this._state.data[mod.eventID]).findIndex(function (_mod) {
            return _mod.moderatorID === mod.moderatorID;
        });
        if (i === -1) return this;
        this._state.data[mod.eventID].splice(i, 1);
        if (this._state.data[mod.eventID].length === 0) {
            delete this._state.data[mod.eventID];
        }
        return this.publish();
    }
})

export default Chat;
